import { Box as BoxMui } from '@mui/material';
import { styledWithLayoutProps } from '../../utils/styled-with-layout-props';

export const StyledBox = styledWithLayoutProps(BoxMui);
